import React, { FC } from "react";

import { Image } from "../../../common/Image";
import { tabFeatureAttributeBlock } from "../elementIDs";
import { ITabFeatureAttributeBlock_AttributeTab } from "../models";

import styles from "./TabFeatureAttributeBlockAttributeTabButton.module.scss";

interface IProps {
    idx: number;
    tab: ITabFeatureAttributeBlock_AttributeTab;
    onClick: () => void;
    isSelected: boolean;
}

export const TabFeatureAttributeBlockAttributeTabButton: FC<IProps> = ({
    idx,
    tab,
    onClick,
    isSelected,
}) => {
    return (
        <button
            className={styles.root}
            id={tabFeatureAttributeBlock.attributeTabButton(tab, idx)}
            type="button"
            role="tab"
            aria-controls={tabFeatureAttributeBlock.attributeTabContent(
                tab,
                idx,
            )}
            tabIndex={isSelected ? 0 : -1}
            aria-selected={isSelected}
            onClick={onClick}
        >
            <span className={styles.label}>{tab.attribute_value}</span>
            <div className={styles.iconCircle}>
                <div className={styles.iconBg}>
                    <div className={styles.icon}>
                        <Image alt={tab.icon.title} src={tab.icon.url} />
                    </div>
                </div>
            </div>
        </button>
    );
};
